(function(angular){
	'use strict';
	
	angular
		.module('homeModule')
		.controller('HomeController', [
			'$cookies',
			'globalConfig',
			'mixpanelFactory',
			HomeControllerFunction
		]);
	
	function HomeControllerFunction(
		$cookies, 
		globalConfig, 
		mixpanelFactory
	){
		var home = this;

		home.$onInit = function() {
			angular.extend(home, globalConfig);

			if (home.includeHomepageAbTest) {
				var cookieJson = $cookies.get('com.fundrise.home');

				if (cookieJson) {
					var homepageCookie = JSON.parse(cookieJson);
					mixpanelFactory.track('AB Test Homepage Viewed', homepageCookie);
				}
			}
		};
	}
})(window.angular);